import React from "react";
import Header from "../../Header/Header";
import StrategyAssementThreeMain from "./StrategyAssementThreeMain";

const StrategyAssesmentThreeBody = () => {
    return (
        <div id="strategy_Assesment_Three">
            <Header title={"Strategy Assesment"} domId="strategy_Assesment_Three" />
            <StrategyAssementThreeMain />
        </div>
    );
};

export default StrategyAssesmentThreeBody;
